import { useServiceContext } from "../Context/ServiceProvider";

// Returns { route, labels, apiModule, service } for the current ServiceProvider.
export const useServiceConfig = () => useServiceContext();
